module.exports = __webpack_public_path__ + "img/home.52fed84b.svg";